export enum Status {
  SuccessUpdatePassword = 'success_update_password',
}

export enum TokenStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Deleted = 'DELETED',
}
